import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EditCasePage } from './edit-case.page';

const routes: Routes = [
  {
    path: '',
    component: EditCasePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditCasePageRoutingModule {}
